import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchQuoteRequestWeight } from "#modules/quoteRequests/infra/fetchQuoteRequestWeight.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const quoteRequestWeightQuery = (id: string | undefined, enabled: boolean) => ({
  queryKey: queryKeys.quoteRequests.weight(id),
  queryFn: () => fetchQuoteRequestWeight(id!),
  staleTime: STALE_TIME,
  enabled: !!id && enabled,
});
